import { render, staticRenderFns } from "./WareHousesFilters.vue?vue&type=template&id=58c87136&"
import script from "./WareHousesFilters.vue?vue&type=script&lang=js&"
export * from "./WareHousesFilters.vue?vue&type=script&lang=js&"
import style0 from "./WareHousesFilters.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58c87136')) {
      api.createRecord('58c87136', component.options)
    } else {
      api.reload('58c87136', component.options)
    }
    module.hot.accept("./WareHousesFilters.vue?vue&type=template&id=58c87136&", function () {
      api.rerender('58c87136', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/management/warehouses/views/components/WareHousesFilters.vue"
export default component.exports